module.exports = __webpack_public_path__ + "img/er.er51a82d5.svg";